import React, { useState } from 'react';
import { Modal, Form, Input, Button, message } from 'antd';
import { updateClient } from '../../Utils/client/client';

const ClientPSWChange = ({ visible, userId, onCancel }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onFinish = (values) => {
    setLoading(true);
    // Simulating an API call
    setTimeout(() => {
      try {
        if (!userId) {
          throw new Error('User ID is required!');
        }
        if (!values.newPassword || !values.confirmPassword) {
          throw new Error('Please fill in all fields!');
        }
        if (values.newPassword !== values.confirmPassword) {
          throw new Error('Passwords do not match!');
        }
        updateClient(userId, { password: values.newPassword });
        message.success('Mot de passe changé avec succès!');
        onCancel();
      } catch (error) {
        message.error('Erreur lors du changement du mot de passe!');
      }
      setLoading(false);
      
    }, 1000);
  };

  return (
    <Modal
      open={visible}
      title="Changer le mot de passe"
      onCancel={onCancel}
      footer={null}
    >
      <Form form={form} onFinish={onFinish} layout="vertical">
        <Form.Item
          name="newPassword"
          label="Nouveau mot de passe"
          rules={[
            { required: true, message: 'Veuillez entrer votre nouveau mot de passe!' },
            { min: 6, message: 'Le mot de passe doit contenir au moins 6 caractères' },
          ]}
        >
          <Input.Password autoComplete="new-password"  />
        </Form.Item>
        <Form.Item
          name="confirmPassword"
          label="Confirmer le nouveau mot de passe"
          rules={[
            { required: true, message: 'Veuillez confirmer votre nouveau mot de passe!' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('newPassword') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('Les deux mots de passe ne correspondent pas!'));
              },
            }),
          ]}
        >
          <Input.Password autoComplete="new-password"  />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading} block>
            Changer le mot de passe
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ClientPSWChange;